import {
    Button, Modal, Form, App, Radio, Input
  } from 'antd';
// import {
//     WarningOutlined,  
//   } from '@ant-design/icons';
import React, {useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import useOnlineStatus from "../../utility/hooks/useOnlineStatus";


const EditTyre = ( {isEditTyreModalVisible, setIsEditTyreModalVisible, currentTyreRequest, vehicle, popupTyre, setPopupTyre} ) => {
    const { t } = useTranslation();
    const { isOnline } = useOnlineStatus();
    const { notification } = App.useApp();
    const [ loadingProgress ] = useState(0);  //start 0 - button shows loading if less than 100
    const [editTyreForm] = Form.useForm();
    const currentTyreRequestBeingEdited = currentTyreRequest?.tyres?.find(tyre => tyre.tyreId === popupTyre?.id);
    const [showAdditionalTyreFields, setShowAdditionalTyreFields] = useState(false);

    const axlePositionDescription = t('message.tyre_position_description', {0: popupTyre?.axleNumber, 1: popupTyre?.axlePositionDescription});

    // is used to repopulate the modal if driver decided to edit the ancillaries booking request
    useEffect(() => {
        editTyreForm.resetFields();
        
        if (currentTyreRequestBeingEdited){
           editTyreForm.setFieldsValue({tyreReviewOutcome: currentTyreRequestBeingEdited?.tyreReviewOutcome});
           editTyreForm.setFieldsValue({tyreBrand: currentTyreRequestBeingEdited?.tyreBrand});
           editTyreForm.setFieldsValue({tyreSize: currentTyreRequestBeingEdited?.tyreSize});
           handleTyreReviewOutcome(currentTyreRequestBeingEdited?.tyreReviewOutcome);
        } 
      }, [editTyreForm, currentTyreRequestBeingEdited, popupTyre]);

      const onFinish = (values) => {
        notification.destroy();

        const newTyreBookingRequest = {
            ...values,
            tyreId: popupTyre?.id,
            tyreReviewOutcome: values.tyreReviewOutcome,
            replacementTyreBrand: values.tyreBrand,
            replacementTyreSize: values.tyreSize,
            axlePositionDescription: axlePositionDescription,                 
        }

        if (currentTyreRequest){
            if (currentTyreRequest.hasOwnProperty('tyres')){
                let currentTyre = currentTyreRequest.tyres.find(tyre => tyre.tyreId === newTyreBookingRequest.tyreId);
                const indexOfExistingTyre = currentTyreRequest.tyres.indexOf(currentTyre);
                
                // if a tyre request exists and the driver updates it, then that old request will be removed and replaced with the latest updates;
                // hence a new request will always be pushed into currentTyreRequest.tyres 
                if (currentTyre && !(indexOfExistingTyre < 0)){
                    currentTyreRequest.tyres.splice(indexOfExistingTyre, 1)
                } 
                currentTyreRequest.tyres.push(newTyreBookingRequest);
            } else {
                currentTyreRequest.tyres = [];
                currentTyreRequest.tyres.push(newTyreBookingRequest);
            }
        }

        editTyreForm.resetFields();
        setIsEditTyreModalVisible(false);   
        setPopupTyre(null);   
        setShowAdditionalTyreFields(false);   
      }

      const onFinishFailed = (errorInfo) => {
        console.log('Form Failed:', errorInfo);
      };

      const removeTyreBookingRequest = (current) => {
        const indexOfCurrentTyre = currentTyreRequest.tyres.indexOf(current);
        if (!(indexOfCurrentTyre < 0)){
            currentTyreRequest.tyres.splice(indexOfCurrentTyre, 1)
        }
        setIsEditTyreModalVisible(false); 
        setShowAdditionalTyreFields(false);
        setPopupTyre(null);
      }

      function handleTyreReviewOutcome(response) 
      {
        setShowAdditionalTyreFields(false);
        if (response === 'REPLACE')
        {
            setShowAdditionalTyreFields(true);
        }
      }      

    return (
      
        <Modal className="std-portal-popup dp-wrap-card-title" 
               open={isEditTyreModalVisible}
               title={axlePositionDescription}
               closable={true}
               keyboard={true}
               footer={
                 isOnline
                 ?
                 [
                  <Button key="cancel" 
                          onClick={(e) => {
                            setIsEditTyreModalVisible(false); 
                            notification.destroy();
                            editTyreForm.resetFields();
                            setShowAdditionalTyreFields(false);
                            setPopupTyre(null);
                          }}
                  >
                    {t('action.cancel')}
                  </Button>,
                  !currentTyreRequestBeingEdited
                  ? 
                  <></> 
                  :
                  <Button key="remove" 
                          type="primary" 
                          danger 
                          onClick={() => removeTyreBookingRequest(currentTyreRequestBeingEdited)}>
                    {t('action.remove')}
                  </Button>,
                  <Button type="primary" 
                          form="editTyreRequest"
                          loading={loadingProgress !== 100 && !vehicle} 
                          key="submit"
                          htmlType="submit"
                  >
                    {t('action.save')}
                  </Button>
                ]
                :
                <></>
               }
               onCancel={() => {
                setIsEditTyreModalVisible(false);
                editTyreForm.resetFields();
                setPopupTyre(null);
                setShowAdditionalTyreFields(false);
               }}
        >
            <Form form={editTyreForm} 
                  layout="vertical"
                  name="editTyreRequest"
                  style={{"width": "100%"}} 
                  onFinish={onFinish}  
                  onFinishFailed={onFinishFailed}
            >
                <Form.Item name={'tyreReviewOutcome'} 
                            style={{ fontSize: '20px' }}
                            label={ t('field.work_required')}
                            layout='horizontal'
                            rules={[
                            { required: true, message: t('error.no_value_named', {0: t('field.work_required')})},
                            ]}
                >
                    <Radio.Group 
                    options={[{value:'REPLACE', key:'REPLACE', label: t('action.replace')}, 
                                {value:'REPAIR', key:'REPAIR', label: t('action.repair')}]}
                    optionType="button"
                    buttonStyle="solid"
                    onChange={(e) => {
                        handleTyreReviewOutcome(e.target.value);
                    }}
                    >
                    </Radio.Group>   
                </Form.Item>  

                {
                 showAdditionalTyreFields
                 ?
                 <>
                 <Form.Item name="tyreBrand" 
                            label={t('field.brand')}
                            rules={[
                                { required: true, message: t('error.no_value_named', {0: t('field.brand')}) },
                                () => ({
                                    validator(_, value) {
                                        if (!value) {
                                            return Promise.reject();
                                        }
                                        return Promise.resolve();
                                        },
                                        }),
                            ]}
                 >
                    <Input allowClear={true}
                           type={'text'} 
                           maxLength={25}
                           placeholder={t('field.tyre_brand_example')} 
                    />
                 </Form.Item>  
                 <Form.Item name="tyreSize" 
                            label={t('field.size')}
                            rules={[
                                { required: true, message: t('error.no_value_named', {0: t('field.size')}) },
                                () => ({
                                    validator(_, value) {
                                        if (!value) {
                                            return Promise.reject();
                                        }
                                        return Promise.resolve();
                                        },
                                        }),
                            ]}
                 >
                    <Input allowClear={true}
                           type={'text'} 
                           maxLength={25}
                           placeholder={t('field.tyre_size_example')} 
                    />
                 </Form.Item>
                 </>
                 :
                 <></>                   
                }                             
                            
          </Form>
        </Modal>
    );
}

export default EditTyre;